import { BlockUI } from "primereact/blockui";
import { ProgressSpinner } from "primereact/progressspinner";
import { usePromiseTracker } from "react-promise-tracker";

export const LoadingIndicator = () => {
  const { promiseInProgress } = usePromiseTracker({});
  return (
    <BlockUI
      blocked={promiseInProgress}
      fullScreen
      template={<ProgressSpinner />}
    />
  );
};
